import { Routes } from '@angular/router';
import { AppRoutes } from '@app/routes/app.route';

export const routes: Routes = AppRoutes;
